/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AssociateActiveOrderProjectDto interface.
 */
export function instanceOfAssociateActiveOrderProjectDto(value) {
    return true;
}
export function AssociateActiveOrderProjectDtoFromJSON(json) {
    return AssociateActiveOrderProjectDtoFromJSONTyped(json, false);
}
export function AssociateActiveOrderProjectDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
    };
}
export function AssociateActiveOrderProjectDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'orderId': value['orderId'],
        'projectId': value['projectId'],
    };
}
